var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(this.$store.state.general.isLoading > 0)?_c('Spinner'):_vm._e(),_c('AuthenticationModal'),_c('router-view',{key:_vm.$route.params.lang})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }